import { useTranslation } from 'react-i18next'

import { article } from '@/shared/lib/articleStyles'

export type NewsArticleSourceRef = {
    href: string
    domain: string
    label: string
}

export function faviconUrl(domain: string) {
    return `https://www.google.com/s2/favicons?domain=${domain}&sz=64`
}

export function createNewsArticleSourceChip<const Refs extends Record<string, NewsArticleSourceRef>>(
    refs: Refs,
    i18nKey: (field: string) => string,
) {
    return function NewsArticleSourceChip({ source }: { source: keyof Refs & string }) {
        const { t } = useTranslation()
        const ref = refs[source]
        const label = t(i18nKey(`ref.${source}.label`), ref.label)
        return (
            <a
                href={ref.href}
                target='_blank'
                rel='noopener noreferrer'
                className={article.sourceChip}
                title={t(i18nKey('sourceChipTitle'), 'Fuente: {{label}}', { label })}
                aria-label={t(i18nKey('sourceChipTitle'), 'Fuente: {{label}}', { label })}
            >
                <img src={faviconUrl(ref.domain)} alt='' width={14} height={14} loading='lazy' decoding='async' />
            </a>
        )
    }
}
